// libs/notify.js
// setupNotify(fn) で実体を登録 → notify(...) で利用。
let notifyImplementation = null;
/**
 * 実体（Element UI / Element Plus の通知関数など）を登録
 * @param {(opts: object) => any} fn
 */
export function setupNotify(fn) {
  notifyImplementation = fn;
}
/**
 * 通知を表示する共通関数
 * @param {object} opts - { title, message, type, position, duration, offset, showClose, ... }
 * @returns {*} 実体の戻り値（通知インスタンスなど）
 */
export function notify(opts = {}) {
  if (!notifyImplementation) {
    if (process && process.env && process.env.NODE_ENV !== 'production') {
      console.warn('[notify] setupNotify() が未設定です。先に実体を登録してください。opts=', opts);
    }
    return;
  }
  return notifyImplementation(opts);
}
// ショートカット
notify.success = (o = {}) => notify({ ...o, type: 'success' });
notify.error = (o = {}) => notify({ ...o, type: 'error' });
notify.info = (o = {}) => notify({ ...o, type: 'info' });
notify.warning = (o = {}) => notify({ ...o, type: 'warning' });
